module.exports = __webpack_public_path__ + "static/media/sg-flag-small.6327ca71.svg";